// The pages are static HTML. Thus an ID that is missing is a programming error.
export function $<T extends HTMLElement = HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (!element) throw new Error(`No element has the ID "${id}".`);
  return element as T;
}

export async function errorText(response: { json(): Promise<unknown> }, fallback: string): Promise<string> {
  const data = (await response.json().catch(() => ({}))) as { error?: string };
  return data.error ?? fallback;
}

// Makes an element. Text goes in with `textContent` only: text from other people is text, never HTML.
export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<HTMLElementTagNameMap[K]> = {},
  ...children: (Node | string | null)[]
): HTMLElementTagNameMap[K] {
  const element = Object.assign(document.createElement(tag), props);
  for (const child of children) if (child !== null) element.append(child);
  return element;
}
